<template>
   
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 轮询管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>执行记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <el-card shadow="hover"  class="searchChooseCard" >
                    <el-input v-model.trim="query.modelName" placeholder="计划名称" class="handle-input mr10"></el-input> 
                    <el-input v-model.trim="query.taskId" placeholder="计划ID" style="width:130px" class="handle-input mr10"></el-input> 
                
                     <el-select v-model="query.taskType"  placeholder="计划类型"  clearable   style="width:130px;margin-right:10px;" @clear="resetSelect" class="handle-select mr10">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="升值计划"  /> 
                        <el-option value="2" label="发售计划"  />   
                        <el-option value="2" label="售罄计划"  />   
                    </el-select>
                    
                    <el-select v-model="query.taskStatus"  placeholder="执行状态"  clearable   style="width:130px;margin-right:10px;" @clear="resetSelect" class="handle-select mr10">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="成功"  /> 
                        <el-option value="2,3" label="失败"  />   
                    </el-select> 
                    <el-date-picker v-model="query.startTime" picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd"  style="width:130px;margin-right:10px;" type="date" placeholder="开始日期"></el-date-picker>
                 
                 <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button>
                 
                    <el-button  type="danger" plain  style="float:right;"  @click="delMore" >删除记录</el-button>  
                    <el-button  type="danger" style="float:right;margin-right:10px"  @click="delAll" >清空记录</el-button> 
                 
               
        </el-card>
        <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="id" width="80" align="center" label="执行ID"></el-table-column> 
                <el-table-column prop="taskId" width="80" align="center" label="计划ID"></el-table-column> 
                <el-table-column prop="taskName" min-width="150" align="left" label="计划名称">  </el-table-column>  
                <el-table-column prop="goodsName"min-width="150" align="left" label="关联藏品">  </el-table-column>  
                <el-table-column prop="taskType" width="90" align="left" label="计划类型"> 
                    <template slot-scope="scope">
                     {{scope.row.taskType=='1'?'升值计划':scope.row.taskType=='2'?'发售计划':scope.row.taskType=='3'?'售罄计划':scope.row.taskType}}
                    </template>
                </el-table-column> 
                <el-table-column prop="taskStatus" width="80" align="left" label="执行结果">
                    <template slot-scope="scope">
                     <el-tag :type="scope.row.taskStatus=='1'?'success':scope.row.taskStatus=='2'?'danger':scope.row.taskStatus=='3'?'danger':'info'" >{{scope.row.taskStatus=='1'?'成功':scope.row.taskStatus=='2'?'失败':scope.row.taskStatus=='3'?'异常':scope.row.taskStatus}}</el-tag>
                    </template> 
                </el-table-column>  
                <el-table-column prop="errorInfo" min-width="200" align="left" label="失败说明">
                    <template slot-scope="scope">
                        <span style="font-size:12px;">{{scope.row.taskInfo}}</span>
                    </template> 
                </el-table-column>
                <el-table-column prop="startTime" width="200" align="center" label="执行时间">
                    <template slot-scope="scope"> 
                        {{scope.row.startTime}}  
                    </template> 
                </el-table-column>    
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 30, 100]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
        <el-dialog :close-on-click-modal="false" title="来源配置" :modal-append-to-body='false' :visible.sync="editVisible"  center="true" top="80px"  width="350px">
            <el-button style="margin-top:-30px;float:left;"  type="danger" plain icon="el-icon-lx-delete"  class="handle-del mr10"  @click="delLog" >批量删除</el-button>  
            <el-button style="margin-top:-30px;float:left;" type="primary" plain  icon="el-icon-lx-roundadd"  class="handle-del mr10"  @click="addBind" >新增来源</el-button> 
            
            <el-table :data="tableData2" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="id" width="70" align="center" label="ID"></el-table-column> 
                <el-table-column prop="name" min-width="100" align="center" label="来源名称"></el-table-column>
                <el-table-column label="操作" min-width="60" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <el-button size="mini" icon="el-icon-lx-share" @click="copyLink(scope.$index, scope.row)" ></el-button> 
                    </template>
                </el-table-column>   
            </el-table> 
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="新增来源" :modal-append-to-body='false' :visible.sync="addVisible"  center="true" top="120px"  width="280px">
             <el-form ref="form" :model="form1" label-width="80px">
                <el-form-item label="来源名称" >
                    <el-input  type="text" placeholder="中文名称"  v-model.trim="form1.name"></el-input>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import {fetchData,saveForm,handDeleteAll,handDeleteMore,fetchData2,task,taskSelect} from '../../../api/taskLog';
import {fetchSelect} from '../../../api/goodsAdd';
 
export default {

    data() {
        return {    
            taskUse:false,
            mid:'',
            secret:'',
            stationId:'', 
            shopCode:'',
            loginName:'', 
            shopLink:'', 
            select:'',
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            }, 
            tableData: [],
            tableData2:[],
            multipleSelection: [],
            delList: [], 
            editVisible:false,
            addVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {  
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted: function () { 
        this.mid = localStorage.getItem('ms_mid');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.secret = localStorage.getItem('ms_secret');
        this.shopCode = localStorage.getItem('ms_shopCode');  
        //查询列表
        this.getData();  
        this.getSelect();
    },

    methods: {  
         
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'startTime');  
            this.$set(this.query, 'modelName','');  
            this.$set(this.query, 'taskId','');
            this.$set(this.query, 'taskStatus'); 
            this.$set(this.query, 'taskType');  
            this.getData();  
        },   
         //刷新
        refresh(){
            history.go(0); 
        },
        //获取下拉框数据
        getSelect(){ 
            this.select = {};
            this.select.mid = this.mid;
            this.select.stationId = this.stationId;
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        },

        //查询
        getData(){
            // 获取列表数据  
            this.query.mid = this.mid;
            this.query.shopCode = this.shopCode;
            this.query.stationId = this.stationId; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                     this.tableData = null;
                    this.pageTotal = 0;  
                } 
            });
        },
 
        // 删除
        handDelete(index, row) {  
            this.form.gid=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success('删除成功'); 
                        this.query.pageIndex = this.query.pageIndex-1;
                        this.getData(this.query);
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.success(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        //批量删除
        delMore() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的日志");
                return;
            } 
            let ids = ''; 
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            } 
            this.form.id = ids.substr(0,ids.length-1);  
            this.form.shopCode = this.shopCode;
            this.form.stationId = this.stationId;  
            handDeleteMore(this.form).then(res => {
                if(res.code=='200'){ 
                    this.changeFalse(); 
                    this.getData();
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },

        //清空日志
        delAll(){
            this.form.shopCode = this.shopCode;
            this.form.stationId = this.stationId;  
            handDeleteAll(this.form).then(res => {
                if(res.code=='200'){ 
                    this.changeFalse(); 
                    this.getData();
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },
        //取消更改等级
        changeFalse(){ 
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },

        // 启动轮询
        taskStart() {  
            this.taskUse = true; 
            this.$message.success("开始轮询...");
            task().then(res => {  
                this.$message.success("轮询结束！");
                this.taskUse = false;
                this.getData(); 
            });   
        },

        // 失败轮询
        taskError() {  
            this.taskUse = true; 
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要轮训的日志");
                return;
            } 
            let ids = ''; 
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            } 
            this.form.id = ids.substr(0,ids.length-1); 
            
            this.form.stationId = this.stationId;   
            this.$message.success("开始轮询...");
            taskSelect(this.form).then(res => {   
                this.$set(this.query, 'taskStatus'); 
                this.$set(this.query, 'taskInfo'); 
                this.$set(this.query, 'id',this.form.id); 
                this.$message.success("轮询结束！");
                this.taskUse = false;
                this.getData(); 
            });   
        },
        getData2(){
            let data1 = {};
            data1.mid = this.mid;
            data1.stationId = this.stationId;
            data1.shopCode = this.shopCode;
            fetchData2(data1).then(res => {  
                if(res.code=='200'){  
                    this.tableData2 = res.data.list;  
                    this.shopLink = res.data.shopLink; 
                } 
            });
        },
        addBind(){
            this.addVisible = true;
        },
        //保存新增
        saveForm() {  
            this.form1.shopCode = this.shopCode; 
            this.form1.stationId = this.stationId; 
            if( !this.form1.name ){
                this.$message.error("请填写名称");
                return;
            } 
            if(this.form1.name.length>5 ){
                this.$message.error("名称不超过5个字");
                return;
            }   
            this.addVisible = false; 
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData2();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        }, 
        //复制链接
         copyLink(index,row){ 
            var inputElement =  document.getElementById("copyLink");  
            inputElement.value=this.shopLink+"&af="+row.id;
            inputElement.select();
            // 执行浏览器复制命令
            document.execCommand("Copy");
            //提示已复制
            this.$message.success("已复制成功，快去分享吧");
           
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>

<style>
.ql-container{
    min-height:250px; 
  }
.ql-editor{
	height: 250px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
